<template>
  <div class="bg-slate-50 rounded-2xl p-4 border border-slate-200">
    <p class="text-slate-700 text-sm font-medium mb-3">בחרו צבע מוביל לאתר שלכם</p>
    <div class="flex flex-wrap gap-2">
      <button
        v-for="color in colorOptions"
        :key="color.value"
        type="button"
        class="w-10 h-10 rounded-xl transition-all border-2 cursor-pointer"
        :class="modelValue === color.value ? 'border-slate-800 scale-110 shadow-lg' : 'border-transparent hover:scale-105'"
        :style="{ backgroundColor: color.value }"
        @click="$emit('update:modelValue', color.value)"
      >
        <span v-if="modelValue === color.value" class="flex items-center justify-center h-full text-white text-xs">✓</span>
      </button>

      <!-- Custom color button -->
      <button
        type="button"
        class="w-10 h-10 rounded-xl transition-all border-2 cursor-pointer overflow-hidden relative"
        :class="isCustomColor ? 'border-slate-800 scale-110 shadow-lg' : 'border-transparent hover:scale-105'"
        :style="isCustomColor ? { backgroundColor: modelValue } : {}"
        @click="showPicker = true"
      >
        <span
          v-if="!isCustomColor"
          class="w-full h-full flex items-center justify-center text-lg rounded-xl"
          style="background: conic-gradient(red, yellow, lime, aqua, blue, magenta, red)"
        />
        <span v-if="isCustomColor" class="flex items-center justify-center h-full text-white text-xs">✓</span>
      </button>
    </div>

    <!-- Custom color picker popup -->
    <Transition name="fade">
      <div v-if="showPicker" class="mt-3">
        <ColorPicker
          v-model:pureColor="customColor"
          :isWidget="true"
          format="hex"
          useType="pure"
          shape="circle"
          pickerType="chrome"
          class="!w-full"
        />
        <div class="flex gap-2 mt-3">
          <button
            class="flex-1 bg-gradient-to-r from-pink-500 to-purple-600 text-white text-sm font-medium py-2 rounded-xl"
            @click="applyCustomColor"
          >
            אישור
          </button>
          <button
            class="px-4 text-slate-500 text-sm font-medium py-2 rounded-xl border border-slate-200 hover:bg-slate-100"
            @click="showPicker = false"
          >
            ביטול
          </button>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { ColorPicker } from 'vue3-colorpicker';
import 'vue3-colorpicker/style.css';

const props = defineProps<{
  modelValue: string;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();

const showPicker = ref(false);
const customColor = ref(props.modelValue || '#8864ee');

const colorOptions = [
  { value: '#8864ee', label: 'סגול' },
  { value: '#ec4899', label: 'ורוד' },
  { value: '#3b82f6', label: 'כחול' },
  { value: '#10b981', label: 'ירוק' },
  { value: '#f59e0b', label: 'צהוב' },
  { value: '#ef4444', label: 'אדום' },
  { value: '#6366f1', label: 'אינדיגו' },
  { value: '#14b8a6', label: 'טורקיז' },
  { value: '#f97316', label: 'כתום' },
  { value: '#1e293b', label: 'כהה' },
];

const presetValues = colorOptions.map(c => c.value);

const isCustomColor = computed(() =>
  !!props.modelValue && !presetValues.includes(props.modelValue),
);

const applyCustomColor = () => {
  emit('update:modelValue', customColor.value);
  showPicker.value = false;
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
